import { getQueryStringValueByName, getHrefOnBrowserLoad } from '../../utils';
import {
  SHOW_PAGE_TYPE,
  ROUTE_ABOUT_YOUR_BUSINESS,
  ROUTE_REVIEW_PAGE,
  REDIRECT_URI,
  NAVIAGETION_BACK_KEY
} from '../../utils/constants';
import {
  saveBusinessTypeForm,
  redirectToPage,
  redirectToGDPRScreen
} from '../../store/dataCapture';
import {
  REVIEW_PAGE_KEY,
  ABOUT_BUSINESS_PAGE_KEY,
  GDPR_PAGE_KEY,
  BUSINESS_DETAILS_PAGE_KEY
} from './routingConstants';
import { ROUTES_PAGE_CONFIGS } from './routeConfig';
import { redirectToBusinessAccountApp } from '../../utils/redirectUtils';

const ROUTES_PAGE_KEYS = ['BD', 'BF', 'TF', 'CD', 'GD', 'RV'];
const NAVIGATION_KEY = 'navigation';
const NAVIGATION_BACK = 'back';

let currentPageKey = ROUTE_ABOUT_YOUR_BUSINESS;

export const redirectToConditionalRoute = () => {
  switch (redirectToCurrentPage()) {
    case ABOUT_BUSINESS_PAGE_KEY:
      currentPageKey = ABOUT_BUSINESS_PAGE_KEY;
      return saveBusinessTypeForm();
    case GDPR_PAGE_KEY:
      currentPageKey = BUSINESS_DETAILS_PAGE_KEY;
      return redirectToGDPRScreen();
    case REVIEW_PAGE_KEY:
      return redirectToPage(ROUTE_REVIEW_PAGE);
    default: {
      const activePages = getActivePages();
      return redirectToPage(getRouteUrlByKey(activePages[0]));
    }
  }
};

export const setCurrentPage = (pageKey) => {
  currentPageKey = pageKey ? pageKey : currentPageKey;
};

export const getCurrentPage = () => {
  return currentPageKey;
};

export const getNextRoutePath = () => {
  const page = ROUTES_PAGE_CONFIGS.filter((v) => v.pageKey === getNextRoute());
  if (page && page.length > 0) {
    return page[0].path;
  }
  redirectToBusinessAccountApp(getRedirectUri(), '', NAVIAGETION_BACK_KEY);
};

export const getBackRoute = () => {
  const page = ROUTES_PAGE_CONFIGS.filter((v) => v.pageKey === getPrevious());
  if (page && page.length > 0) {
    currentPageKey = page[0].pageKey;
    return page[0].path;
  }
  redirectToBusinessAccountApp(getRedirectUri(), '', NAVIAGETION_BACK_KEY);
};

export const isAccordianNeeded = (key) => {
  const pages = getActivePages();
  return pages && pages.length > 0 && pages.indexOf(key) > -1;
};

const getPrevious = () => {
  const activePages = getActivePages();
  let currentIndex = activePages.indexOf(currentPageKey);
  currentIndex = currentIndex > -1 ? currentIndex - 1 : 0;
  return activePages[currentIndex];
};

const getNextRoute = () => {
  const activePages = getActivePages();
  let currentIndex = activePages.indexOf(currentPageKey);
  currentIndex = currentIndex > -1 ? currentIndex + 1 : 0;
  return activePages[currentIndex];
};

const getActivePages = () => {
  const pages = getQueryStringValueByName(SHOW_PAGE_TYPE);
  return pages ? pages.split(',') : ROUTES_PAGE_KEYS;
};

const getRoutByRouteParam = () => {
  const pages = getActivePages();
  return isBackNavigation() ? pages[pages.length - 1] : pages[0];
};

const LAYOUT_PARAM = 'layout';

const redirectToCurrentPage = () => {
  if (getQueryStringValueByName(LAYOUT_PARAM) === 'page') {
    return getRoutByRouteParam();
  }
  return REVIEW_PAGE_KEY;
};

const getRouteUrlByKey = (key) => {
  const page = ROUTES_PAGE_CONFIGS.filter((v) => v.pageKey === key);
  currentPageKey = page[0].pageKey;
  return page[0].path;
};

const getRedirectUri = () => {
  const url = getHrefOnBrowserLoad();
  return url.split(`${REDIRECT_URI}=`)[1];
};

export const isBackNavigation = () => getQueryStringValueByName(NAVIGATION_KEY) === NAVIGATION_BACK;
